import { CDBBtn } from "cdbreact";
import Select from "react-select";
import data from '../../assets/data/data.json';
import { useEffect, useState } from 'react';

export const ModalProjects = ({
  action,
  setPressedButton,
  formData,
  handleChange,
}) => {

  const [ciudades, setCiudades] = useState([]);
  const [ciudadesDisabled, setCiudadesDisabled] = useState(true);
  const [departamentos, setDepartamentos] = useState([]);
  const [selectedDepartament, setSelectedDepartament] = useState(formData.Department || '');

  const countryCodeOptions = [
    { value: "+57", label: "+57 (Colombia)" },
    { value: "+1", label: "+1 (Estados Unidos)" },
    { value: "+52", label: "+52 (México)" }
  ];

  const isEditAction = action === 'edit';

  const handleDepartamentoChange = (selectedDepartamento) => {
    const departamento = data.find(item => item.departamento === selectedDepartamento);
    if (departamento) {
      const ciudadesOptions = departamento.ciudades.map(ciudad => ({
        value: ciudad,
        label: ciudad
      }));
      setCiudades(ciudadesOptions);
      setCiudadesDisabled(false);
    } else {
      setCiudades([]);
      setCiudadesDisabled(true);
    }
  };

  useEffect(() => {

    const departamentosOptions = data.map(item => ({
      value: item.departamento,
      label: item.departamento
    }));
  
    setDepartamentos(departamentosOptions);
  }, [data]);

  useEffect(() => {
		
		handleDepartamentoChange(formData.Department);

	}, [isEditAction, selectedDepartament]);

  return (
    <div>
      <div className="modal-header">
        <div>
          <h3 className="modal-title" id="exampleModalLabel">
            {action === "create" ? "Crear Proveedor" : "Editando Proveedor"}
          </h3>
        </div>
        {action === "edit" ? (
          <CDBBtn
            size="small"
            className="p-2 btn"
            color="danger"
            outline
            onClick={() => {
              setPressedButton("delete");
            }}
          >
            <i className="fas fa-trash"></i>
            Eliminar Proveedor
          </CDBBtn>
        ) : null}
      </div>
      <div className="modal-body">
          <div className="form-group">
            <label>Código Proveedor:<span className="text-danger"> *</span></label>
            <input
              type="text"
              className="form-control mb-4"
              id="Nit"
              disabled={action === 'edit'}
              placeholder="Código..."
              value={formData.Nit}
              onChange={(e) =>
                handleChange([
                  { id: "Nit", value: e.target.value }
                ])
              }
            />
          </div>

        <div className="form-group">
          <label htmlFor="ProjectName">Nombre:<span className="text-danger"> *</span></label>
          <input
            type="text"
            className="form-control mb-4"
            id="ProjectName"
            placeholder="Nombre del proveedor"
            value={formData.ProjectName}
            onChange={(e) =>
              handleChange([
                { id: "ProjectName", value: e.target.value }
              ])
            }
          />
        </div>

        <div className="form-group row mb-4">
          <label htmlFor="UserDepartment">Departamento:<span className="text-danger"> *</span></label>
          <Select
            id="Department"
            placeholder="Seleccione un Departamento"
            options={departamentos}
            value={departamentos.find((option) => option.value === formData.Department)}
            onChange={(selectedOption) => {
              setSelectedDepartament(selectedOption.value);
              handleChange([
                { id: "Department", value: selectedOption.value }
              ]);
            }}
          />
        </div>

        <div className="form-group row mb-4">
          <label htmlFor="UserCity">Ciudad:<span className="text-danger"> *</span></label>
          <Select
            id="City"
            placeholder="Seleccione un Ciudad"
            isDisabled={ciudadesDisabled}
            options={ciudades}
            value={ciudades.find((option) => option.value === formData.City)}
            onChange={(selectedOption) => {
              handleChange([
                { id: "City", value: selectedOption.value }
              ]);
            }}
          />
        </div>

        <div className="form-group">
          <label htmlFor="ProviderAddress">Dirección:<span className="text-danger"> *</span></label>
          <input
            type="text"
            className="form-control mb-4"
            id="ProviderAddress"
            placeholder="Dirección del proveedor"
            value={formData.ProviderAddress}
            onChange={(e) =>
              handleChange([
                { id: "ProviderAddress", value: e.target.value }
              ])
            }
          />
        </div>

        <div className='d-flex flex-row'>
					<div className='form-group w-20'>
						<label htmlFor='UserCountryCode'>Indicativo País:<span className="text-danger"> *</span></label>
            <Select
              id="UserCountryCode"
              placeholder="Seleccione un indicativo"
              options={countryCodeOptions}
              value={countryCodeOptions.find((option) => option.value === formData.CountryCode)}
              onChange={(selectedOption) => {
                handleChange([
                  { id: "CountryCode", value: selectedOption.value }
                ]);
              }}
            />
					</div>
					<div className='form-group ms-3 flex-grow-1'>
						<label htmlFor='Phone'>Teléfono:<span className="text-danger"> *</span></label>
						<input
							type='text'
							className='form-control mb-4 w-100'
							id='Phone'
							label='Phone'
							placeholder={'3108888888'}
							value={formData.Phone}
							onChange={(e) =>
                handleChange([
                  { id: "Phone", value: e.target.value }
                ])
              }
						/>
					</div>
				</div>

        <div className="form-group">
          <label htmlFor="ProjectDescription">Descripción:</label>
            <textarea
                className="form-control mb-4"
                id="ProjectDescription"
                placeholder="Descripción del proveedor"
                value={formData.ProjectDescription}
                onChange={(e) =>
                  handleChange([
                    { id: "ProjectDescription", value: e.target.value }
                  ])
                }
            />
        </div>

        <div className="modal-footer justify-content-center align-items-center">
          <CDBBtn
            type="button"
            color="danger"
            outline
            onClick={() => setPressedButton("closeModal")}
          >
            Cerrar
          </CDBBtn>
          <CDBBtn
            type="submit"
            color="success"
            className="mr-auto"
            outline
            onClick={() => setPressedButton("submitModal")}
          >
            Guardar
          </CDBBtn>
        </div>
      </div>
    </div>
  );
};